// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__DOTPR","label":"TextInput_label__1fOt_","details":"TextInput_details__3sWIM","input":"TextInput_input__3aFHK"};